export const NOTIFY_APPLICANT_ON_REPORT_CREATED =
  'notify_applicant_on_report_created';
export const NOTIFY_ON_REPORT_CREATED = 'notify_on_report_created';
export const NOTIFY_ON_REPORT_CLEAR = 'notify_on_report_clear';
export const NOTIFY_ON_REPORT_CONSIDER = 'notify_on_report_consider';
export const NOTIFY_ON_REPORT_SUSPENDED = 'notify_on_report_suspended';
